/* =============================================
   Naturalya Chat Widget — Naturally Beauté Cosmetic
   Remplacer BACKEND_URL par l'URL Render réelle
   Exemple : https://naturalya-api.onrender.com
   ============================================= */

(function () {
  "use strict";

  const BACKEND_URL = "https://naturalya-api.onrender.com";

  // ── Session ID — sessionStorage : persiste dans l'onglet, repart à zéro à sa fermeture ──
  function getSessionId() {
    let sid = sessionStorage.getItem("naturalya_session_id");
    if (!sid) {
      sid = "sess_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
      sessionStorage.setItem("naturalya_session_id", sid);
    }
    return sid;
  }

  function newSessionId() {
    const sid = "sess_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    sessionStorage.setItem("naturalya_session_id", sid);
    return sid;
  }

  let SESSION_ID = getSessionId();
  let conversationHistory = [];
  let isLoading = false;

  // ── Injection du HTML ──────────────────────────────────────────────────────
  function buildWidget() {
    const wrapper = document.createElement("div");
    wrapper.id = "naturalya-widget";
    wrapper.innerHTML = `
      <!-- Bubble -->
      <button id="naturalya-bubble" aria-label="Ouvrir le chat Naturalya">
        <div id="naturalya-badge">1</div>
        <svg viewBox="0 0 100 120" xmlns="http://www.w3.org/2000/svg">
          <path d="M50 5 C80 20 90 50 82 78 C74 98 50 115 50 115 C50 115 26 98 18 78 C10 50 20 20 50 5Z" fill="#c9a84c"/>
          <line x1="50" y1="8" x2="50" y2="112" stroke="#1a1a1a" stroke-width="5" stroke-linecap="round"/>
          <path d="M50 38 Q33 28 20 38" stroke="#1a1a1a" stroke-width="4" stroke-linecap="round" fill="none"/>
          <path d="M50 60 Q67 50 80 60" stroke="#1a1a1a" stroke-width="4" stroke-linecap="round" fill="none"/>
          <path d="M50 80 Q35 71 24 80" stroke="#1a1a1a" stroke-width="3.5" stroke-linecap="round" fill="none"/>
        </svg>
      </button>

      <!-- Chat window -->
      <div id="naturalya-window" class="naturalya-hidden" role="dialog" aria-label="Chat Naturalya">
        <div id="naturalya-header">
          <div id="naturalya-avatar">
            <svg viewBox="0 0 100 120" xmlns="http://www.w3.org/2000/svg">
              <path d="M50 5 C80 20 90 50 82 78 C74 98 50 115 50 115 C50 115 26 98 18 78 C10 50 20 20 50 5Z" fill="#1a1a1a"/>
              <line x1="50" y1="8" x2="50" y2="112" stroke="#c9a84c" stroke-width="5" stroke-linecap="round"/>
              <path d="M50 38 Q33 28 20 38" stroke="#c9a84c" stroke-width="4" stroke-linecap="round" fill="none"/>
              <path d="M50 60 Q67 50 80 60" stroke="#c9a84c" stroke-width="4" stroke-linecap="round" fill="none"/>
              <path d="M50 80 Q35 71 24 80" stroke="#c9a84c" stroke-width="3.5" stroke-linecap="round" fill="none"/>
            </svg>
          </div>
          <div id="naturalya-header-info">
            <div id="naturalya-header-name">Naturalya</div>
            <div id="naturalya-header-status">Conseillère beauté · En ligne</div>
          </div>
          <button id="naturalya-new" aria-label="Nouvelle conversation" title="Nouvelle conversation">
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a1 1 0 000-1.41l-2.34-2.34a1 1 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
            </svg>
          </button>
          <button id="naturalya-close" aria-label="Fermer">×</button>
        </div>

        <div id="naturalya-messages" role="log" aria-live="polite"></div>

        <div id="naturalya-input-area">
          <textarea
            id="naturalya-input"
            placeholder="Posez votre question beauté…"
            rows="1"
            maxlength="500"
            aria-label="Votre message"
          ></textarea>
          <button id="naturalya-send" aria-label="Envoyer">
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
            </svg>
          </button>
        </div>

        <div id="naturalya-footer">Propulsé par Naturally Beauté Cosmetic ✨</div>
      </div>
    `;
    document.body.appendChild(wrapper);
  }

  // ── Messages UI ────────────────────────────────────────────────────────────
  function addMessage(role, text) {
    const container = document.getElementById("naturalya-messages");
    const msgDiv = document.createElement("div");
    msgDiv.classList.add("naturalya-msg", role === "user" ? "naturalya-msg-user" : "naturalya-msg-bot");

    if (role === "assistant") {
      msgDiv.innerHTML = `
        <div class="naturalya-msg-bot-avatar">
          <svg viewBox="0 0 100 120" xmlns="http://www.w3.org/2000/svg">
            <path d="M50 5 C80 20 90 50 82 78 C74 98 50 115 50 115 C50 115 26 98 18 78 C10 50 20 20 50 5Z" fill="#1a1a1a"/>
            <line x1="50" y1="8" x2="50" y2="112" stroke="#c9a84c" stroke-width="5" stroke-linecap="round"/>
            <path d="M50 38 Q33 28 20 38" stroke="#c9a84c" stroke-width="4" stroke-linecap="round" fill="none"/>
            <path d="M50 60 Q67 50 80 60" stroke="#c9a84c" stroke-width="4" stroke-linecap="round" fill="none"/>
            <path d="M50 80 Q35 71 24 80" stroke="#c9a84c" stroke-width="3.5" stroke-linecap="round" fill="none"/>
          </svg>
        </div>
        <div class="naturalya-bubble-text">${formatMessage(text)}</div>
      `;
    } else {
      msgDiv.innerHTML = `<div class="naturalya-bubble-text">${escapeHtml(text)}</div>`;
    }

    container.appendChild(msgDiv);
    container.scrollTop = container.scrollHeight;
  }

  function showTyping() {
    const container = document.getElementById("naturalya-messages");
    const typingDiv = document.createElement("div");
    typingDiv.id = "naturalya-typing-indicator";
    typingDiv.classList.add("naturalya-msg", "naturalya-msg-bot");
    typingDiv.innerHTML = `
      <div class="naturalya-msg-bot-avatar">N</div>
      <div class="naturalya-typing">
        <span></span><span></span><span></span>
      </div>
    `;
    container.appendChild(typingDiv);
    container.scrollTop = container.scrollHeight;
  }

  function hideTyping() {
    const el = document.getElementById("naturalya-typing-indicator");
    if (el) el.remove();
  }

  function escapeHtml(str) {
    return str
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/\n/g, "<br>");
  }

  function formatMessage(str) {
    let safe = str
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
    safe = safe.replace(/(https?:\/\/[^\s<]+)/g, function (url) {
      url = url.replace(/[.,;:!?'"]+$/, ""); // retire la ponctuation finale
      const label = url.includes("/products/") ? "Voir le produit →" : url;
      return `<a href="${url}" target="_blank" rel="noopener noreferrer" class="naturalya-link">${label}</a>`;
    });
    return safe.replace(/\n/g, "<br>");
  }

  function saveHistory() {
    sessionStorage.setItem("naturalya_history", JSON.stringify(conversationHistory));
  }

  function loadHistory() {
    try {
      return JSON.parse(sessionStorage.getItem("naturalya_history") || "[]");
    } catch (_) {
      return [];
    }
  }

  // ── Appel API ──────────────────────────────────────────────────────────────
  async function sendMessage(userText) {
    if (isLoading || !userText.trim()) return;
    isLoading = true;

    conversationHistory.push({ role: "user", content: userText });
    saveHistory();
    addMessage("user", userText);
    showTyping();

    try {
      const res = await fetch(`${BACKEND_URL}/chat`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          messages: conversationHistory,
          session_id: SESSION_ID,
        }),
      });

      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      const reply = data.reply || "Désolée, je n'ai pas pu répondre. Réessayez !";

      hideTyping();
      addMessage("assistant", reply);
      conversationHistory.push({ role: "assistant", content: reply });
      saveHistory();
    } catch (err) {
      hideTyping();
      addMessage(
        "assistant",
        "Oups, une erreur est survenue 😔 Veuillez réessayer ou contacter notre support."
      );
      console.error("[Naturalya]", err);
      conversationHistory.pop();
      saveHistory();
    } finally {
      isLoading = false;
    }
  }

  // ── Gestion ouverture/fermeture ────────────────────────────────────────────
  let isOpen = false;
  let hasGreeted = false;

  function openChat() {
    const win = document.getElementById("naturalya-window");
    const badge = document.getElementById("naturalya-badge");
    win.classList.remove("naturalya-hidden");
    isOpen = true;
    badge.style.display = "none";
    document.getElementById("naturalya-input").focus();

    if (!hasGreeted) {
      hasGreeted = true;
      setTimeout(() => {
        addMessage(
          "assistant",
          "Bonjour ! 🌿 Je suis Naturalya, votre conseillère IA. Produits, soins, commandes, conseils… dites-moi ce dont vous avez besoin, je ferai au mieux pour vous répondre !"
        );
      }, 350);
    }
  }

  function closeChat() {
    document.getElementById("naturalya-window").classList.add("naturalya-hidden");
    isOpen = false;
  }

  function resetConversation() {
    SESSION_ID = newSessionId();
    conversationHistory = [];
    sessionStorage.removeItem("naturalya_history");
    hasGreeted = false;
    document.getElementById("naturalya-messages").innerHTML = "";
    setTimeout(() => {
      addMessage(
        "assistant",
        "Nouvelle conversation ! 🌿 Je suis Naturalya, votre conseillère IA. Comment puis-je vous aider ?"
      );
      hasGreeted = true;
    }, 200);
  }

  // ── Auto-resize textarea ───────────────────────────────────────────────────
  function autoResize(el) {
    el.style.height = "auto";
    el.style.height = Math.min(el.scrollHeight, 100) + "px";
  }

  // ── Init ───────────────────────────────────────────────────────────────────
  function init() {
    buildWidget();

    conversationHistory = loadHistory();
    if (conversationHistory.length > 0) {
      hasGreeted = true;
      conversationHistory.forEach(function (msg) { addMessage(msg.role, msg.content); });
    }

    const bubble = document.getElementById("naturalya-bubble");
    const closeBtn = document.getElementById("naturalya-close");
    const newBtn = document.getElementById("naturalya-new");
    const sendBtn = document.getElementById("naturalya-send");
    const input = document.getElementById("naturalya-input");
    const badge = document.getElementById("naturalya-badge");

    bubble.addEventListener("click", () => (isOpen ? closeChat() : openChat()));
    closeBtn.addEventListener("click", closeChat);
    newBtn.addEventListener("click", resetConversation);

    sendBtn.addEventListener("click", () => {
      const text = input.value.trim();
      if (text) {
        input.value = "";
        autoResize(input);
        sendMessage(text);
      }
    });

    input.addEventListener("keydown", (e) => {
      if (e.key === "Enter" && !e.shiftKey) {
        e.preventDefault();
        sendBtn.click();
      }
    });

    input.addEventListener("input", () => autoResize(input));

    // Badge d'attention après 5s si le chat n'est pas encore ouvert
    setTimeout(() => {
      if (!isOpen) {
        badge.style.display = "flex";
      }
    }, 5000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
